import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/login/login-index'
import Register from '../pages/login/login-register'
import Choose from '../pages/login/login-choose'
import ForgetPassword from '../pages/login/forget-password';
import Page404 from '../pages/404.vue'
import UnDistributeShop from '../pages/unLogin/distributeShop/layout.vue'
import UnProductDetail  from "../pages/unLogin/productDetail"
import WxMiniRedirect  from "../pages/unLogin/wxMiniRedirect"
import DownloadCenter from '../pages/distributor/trade/downloadCenter/index.vue';
import ShipmentDetail from '@supplier/dangkou/shipmentDetail/index.vue';
import HycBulkShelves from '@/pages/hyc/bulkShelves.vue';
import HycBatchBulkShelves from '@/pages/hyc/batchBulkShelves.vue';
import HycGroupBulkShelves from '@/pages/hyc/groupBulkShelves.vue';
import ErpTaskCenterPage from '@/pages/common/ErpTaskCenter.vue';

import distributorRoutes from './distributor'
import supplierRoutes from './supplier'
import _ from 'lodash'

Vue.use(VueRouter)

let defaultRoutes = [
  {
    path: '/login/index',
    name: 'l_index',
    component: Login
  },
  {
    path: '/login/register',
    name: 'l_register',
    component: Register
  },
  {
    path: '/login/choose',
    name: 'l_choose',
    component: Choose
  },
  {
    path: '/login/forgetPassowrd',
    name: 'l_forgetPassowrd',
    component: ForgetPassword
  },
  {
    path: '*',
    name: '404',
    component: Page404
  },
  {
    path: '/unlogin/distributeShop',
    name:'un_distributeShop',
    component: UnDistributeShop
  },
  {
    path: '/unlogin/productDetail',
    name:'un_productDetail',
    component: UnProductDetail
  },
  {
    path: '/unlogin/wxMiniRedirect',
    name:'un_wxMiniRedirect',
    component: WxMiniRedirect
  },
  {
    path: '/supplier/dangkou/shipment/detail',
    name:'shipmentItemDetail',
    component: ShipmentDetail
  },
  {
    path: '/hyc/bulkShelves',
    name:'hyc_bulkShelves',
    component: HycBulkShelves
  },
  {
    path: '/hyc/groupBulkShelves',
    name:'hyc_GroupBulkShelves',
    component: HycGroupBulkShelves
  },
  {
    path: '/hyc/batchBulkShelves',
    name:'hyc_batchBulkShelves',
    component: HycBatchBulkShelves
  },
  // 拼多多外链
  {
    path: '/pdd/outer_link',
    name: 'pdd_outer_link',
    component: () => import('@/pages/other/outer_link/index.vue'),
  },
  {
    path: '/outdetail/outer_link',
    name: 'outdetail_outer_link',
    component: () => import('@/pages/other/outer_link/index.vue'),
  },
]

// 无需后端配置菜单权限的菜单
const distributorNotPermissionRoutes = [
  {
    path: 'download_center',
    name: 'd_DownloadCenter',
    component: DownloadCenter,
    meta: {
      title: '下载中心',
      icon: 'el-icon-download'
    },
    hide: true
  },
  {
    path: 'stock_sync_logs',
    name: 'd_erpStockLogs',
    component: DownloadCenter,
    meta: {
      title: 'erp库存上传日志',
    },
    hide: true
  },
  {
    path: 'erp_task_center',
    name: 'd_erpTaskCenter',
    component: () => import('@/pages/common/ErpTaskCenter.vue'),
    meta: {
      title: '任务中心',
    },
    hide: true
  }
]
const supplierNotPermissionRoutes = [
  {
    path: 'download_center',
    name: 's_DownloadCenter',
    component: DownloadCenter,
    meta: {
      title: '下载中心',
      icon: 'el-icon-download'
    },
    hide: true
  },
  {
    path: 'stock_sync_logs',
    name: 's_erpStockLogs',
    component: DownloadCenter,
    meta: {
      title: 'erp库存上传日志',
    },
    hide: true
  },
  {
    path: 'erp_task_center',
    name: 's_erpTaskCenter',
    component: ErpTaskCenterPage,
    meta: {
      title: '任务中心',
      icon: 'el-icon-document'
    },
    hide: true,
  }
]

// 路由菜单已与后端接口关联
// 若新增菜单要开发，请调整下列代码块
if (process.env.NODE_ENV === 'development') {
  defaultRoutes = defaultRoutes.concat([
    ...distributorRoutes,
    ...supplierRoutes
  ])
}

const createRouter = () => {
  return new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: window.__index_router ? [...defaultRoutes, window.__index_router] : defaultRoutes
  })
}

/* 初始化根跳转问题 */
const initRootRouter = (menusPaths) => {
  if (menusPaths.includes('/supplier/index')) {
    // 往首页跳转
    window.__index_router = {
      path: '/',
      redirect: '/supplier/index'
    }
  } else if(menusPaths.includes('/distributor/index')) {
    // 往首页跳转
    window.__index_router = {
      path: '/',
      redirect: '/distributor/index'
    }
  } 
  // if (menusPaths.includes('/supplier/prod/center')) {
  //   // 先往商品中心跳
  //   window.__index_router = {
  //     path: '/',
  //     redirect: '/supplier/prod/center'
  //   }
  // } else if(menusPaths.includes('/distributor/prod/center')) {
  //   // 先往商品中心跳
  //   window.__index_router = {
  //     path: '/',
  //     redirect: '/distributor/prod/center'
  //   }
  // } 
  else if(menusPaths.length > 0) {
    // 商品中心没得就取第一个路由跳
    window.__index_router = {
      path: '/',
      redirect: menusPaths[0]
    }
  } else {
    // 都没有就往登录页跳
    window.__index_router = {
      path: '/',
      redirect: '/login/index'
    }
  }
}


// 格式化菜单配置
// 返回数组
// 数组[0] -> 以path为key 对应菜单配置为vlaue的对象
// 数组[1] -> 数组[0]的key集合
const flatMenuConf = function (menuConf) {
  const flat = {}

  function childrenFlat(menu) {
    if (menu.children && menu.children.length) {
      menu.children.forEach(childrenFlat)
    }
    if (!menu.path) return;
    flat[menu.path] = menu
  }

  menuConf.forEach(childrenFlat)
  return [flat, Object.keys(flat)]
}

// 保留存在的菜单
const filterMenu = function (menu, menusPaths) {
  if (menu.children) {
    menu.children = menu.children.filter(item => {
      return item.meta?.bypassFilter || menusPaths.includes(item.path) || menusPaths.includes(item.meta?.showWithPath)
    })
    if (menu.children.length > 0) {
      menu.children.forEach(mc => {
        filterMenu(mc, menusPaths)
      })
    }
  }
}

// 清理供销商和分销商路由，防止重复加载
function clearRouter($router) {
  let distributorIndex = $router.options.routes.findIndex(r => r.name === "distributor")
  if (distributorIndex > -1) {
    $router.options.routes.splice(distributorIndex, 1);
  }
  let supplierIndex = $router.options.routes.findIndex(r => r.name === "supplier")
  if (supplierIndex > -1) {
    $router.options.routes.splice(supplierIndex, 1);
  }
}

export const setRouter = function(menuConf, $router) {
  console.log('%c [ menuConf ]-204', 'font-size:13px; background:pink; color:#bf2c9f;', menuConf)
  const _distributorRoutes = _.cloneDeep(distributorRoutes);
  const _supplierRoutes = _.cloneDeep(supplierRoutes);
  const [flatMenus, menusPaths] = flatMenuConf(menuConf);
  initRootRouter(menusPaths)
  $router.matcher = createRouter().matcher

  // if (process.env.NODE_ENV === 'development') return;

  clearRouter($router)

  _distributorRoutes.forEach(item => {
    filterMenu(item,menusPaths);
    if (item.children.length > 0) {
      item.children = item.children.concat(distributorNotPermissionRoutes)
      $router.addRoute(item);
      const _index = $router.options.routes.findIndex(r => r.name === item.name)
      if (_index > -1) {
        $router.options.routes[_index] = item
      } else {
        $router.options.routes.push(item);
      }
    }
  })
  _supplierRoutes.forEach(item => {
    filterMenu(item, menusPaths)
    if (item.children.length > 0) {
      item.children = item.children.concat(supplierNotPermissionRoutes)
      $router.addRoute(item);
      const _index = $router.options.routes.findIndex(r => r.name === item.name)
      if (_index > -1) {
        $router.options.routes[_index] = item
      } else {
        $router.options.routes.push(item);
      }
    }
  })
  console.log($router.options.routes, '$router.options.routes')
}

const router = createRouter()

// const originalPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default router
